import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ContactSegment, CreateContactSegmentInput } from '@neuroedge/shared';
import { apiClient, ApiClientError } from './client';

const KEY = ['contact-segments'] as const;

export const listContactSegments = () => apiClient.get<ContactSegment[]>('/contact-segments');
export const createContactSegment = (input: CreateContactSegmentInput) =>
  apiClient.post<ContactSegment>('/contact-segments', input);

export function useContactSegments() {
  return useQuery<ContactSegment[], ApiClientError>({
    queryKey: KEY,
    queryFn: listContactSegments,
  });
}

export function useCreateContactSegment() {
  const qc = useQueryClient();
  return useMutation<ContactSegment, ApiClientError, CreateContactSegmentInput>({
    mutationFn: createContactSegment,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
